import { render, staticRenderFns } from "./userFrom.vue?vue&type=template&id=b5e11296&scoped=true"
import script from "./userFrom.vue?vue&type=script&lang=js"
export * from "./userFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e11296",
  null
  
)

export default component.exports